<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Axp54P/tc-custom/9780740798856.jpg?1709195892298" alt="This image is the cover for the book Heckuva Job, Bushie!, Doonesbury"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heckuva Job, Bushie!, Doonesbury
      </h1>
      <p class="bookDescription body article font2">
        <p>Mike's summer daydream may be the only place we'll ever hear a thorough mea culpa from Dubya. But while mistakes have been made, lessons have been learned, even in the White House, where the Abramoff scandal inspires an official Ethics Refresher Course: "Right, good. Wrong, bad." The president seeks to clarify: "Invasions are still okay, though. Right?" And through these troubled times, how does 43 sleep at night? Alas, not well. "It's the stem cells. I hear their cries." Heckuva job. </p><p>Roland's ubiquitous epaulets have recently come home from Rummyworld, "that vast, tumultuous terrorist theme park that used to be known as Iraq." At its chaotic outer edges, in al-Amok, Proconsul Duke survives numerous assassination attempts and the alleged courting of his sidekick by Iraqi suitors. But the serious new action is in New Orleans ("Looting, graft, profiteering -- it's all about the skill set, Honey") and Team Duke, like Halliburton, embarks for the Golf Coast, and sets up a command post on a FEMA-provided cruise ship.</p><p>Elsewhere on the home front a fully-prostheticized B.D. is increasingly ambulatory, yet finds the struggle to reclaim his mind and emotions is by far the harder part of his journey. The collateral casualty count continues to rise as Zonker is forced to make a traumatic foray into the job market.</p><p>The option-aware Alex launches an ambitious seven-school college tour, including Walden, where she is clued to her father's unbuttoned-down past. "You were a communist?" "That communard!" When campus total-insiders Jeff and Zip give her the ultimate tour, both are smitten by gal Doonesbury's formidable charms: "So how hot is she?" "Easy, Dude, that's my future wife."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        G. B. Trudeau
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d039f3a